<template>
<div>
    <law-matter-budget-report-form ref="lawMatterBudgetReportForm" :lawMatterId="this.id" :dailyworkReload="reloadDailywork"></law-matter-budget-report-form>
    <b-modal id="matterFormModal" ref="matterFormModal" centered size="xl" no-close-on-backdrop :title=" (recordNo == null)?'':recordNo + ' - ' + shortName" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate" hide-footer>
        <b-card>
            <b-row>
                <b-col>
                    <label class="text-danger" v-if="lawClientPowerOfAttorneyDeadlineDate != null">{{ $t('clients.power_of_attorney_deadline_date') + ':' + $formatFn(lawClientPowerOfAttorneyDeadlineDate) }}</label>
                </b-col>
                <b-col>
                    <div class="custom-search d-flex justify-content-end">
                        <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="addOrUpdate">
                            {{ $t('others.ok_title') }}
                        </b-button>
                        <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="budgetReport">
                            {{ $t('others.budget') }}
                        </b-button>
                        <b-button v-if="shouldShowFilesButton" variant="outline-primary" size="sm"  @click.prevent="openMatterFolder">
                            {{ $t('others.show_files') }}
                        </b-button>
                        <b-button v-else-if="shouldShowCreateFilesButton" variant="outline-primary" size="sm" :disabled="creatingDocuments" @click.prevent="createAllDocuments">
                            <b-spinner v-if="creatingDocuments" small></b-spinner>
                            {{ $t('others.create_files') }}
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <validation-observer ref="simpleRules">
                <b-row>
                    <b-col class="col-lg-12">
                        <b-form>
                            <label for="matter-name-input">{{ $t('matter.name') }}</label>
                            <b-form-group>
                                <b-form-input id="matter-name-input" size="sm" v-model="name" maxlength="500" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col class="col-lg-4">
                        <b-form>
                            <validation-provider :name="$t('matter.client')" #default="{ errors }" :rules="{ excluded: 0 }">
                                <label  for="matter-plaintiff-or-libelee-input">{{ $t('matter.client') }}</label>
                                <v-select class="select-size-sm" id="matter-agent-input" v-model="matterClientSelect" :options="matterClientOption" @input="setMatterClientId" label="name" @search="onSearch"></v-select>
                                <b-form-invalid-feedback :state="errors.length > 0 ? false:null"> {{ errors[0] }}</b-form-invalid-feedback>
                            </validation-provider>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <validation-provider :name="$t('matter.agent')" #default="{ errors }" :rules="{ excluded: 0 }">
                                <b-form-group :label="$t('matter.agent')" label-for="matter-agent-input" :state="errors.length > 0 ? false : null">
                                    <v-select class="select-size-sm" id="matter-agent-input" v-model="agentSelect" :options="agentOption" label="clientName" @search="onAgentSearch"></v-select>
                                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-form>
                    </b-col>
                    <b-col class="col-lg-4">
                        <b-form>
                            <validation-provider :name="$t('matter.invoice_agent')" #default="{ errors }" :rules="{ excluded: 0 }">
                                <b-form-group :label="$t('matter.invoice_agent')" label-for="matter-invoice-agent-input" :state="errors.length > 0 ? false : null">
                                    <v-select class="select-size-sm" id="matter-invoice-agent-input" v-model="invoiceAgentSelect" :options="invoiceAgentOption" label="clientName" @search="onInvoiceAgentSearch"></v-select>
                                    <b-form-invalid-feedback :state="errors.length > 0 ? false : null">{{ errors[0] }}</b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col class="col-md-6">
                        <b-form>
                            <label for="matter-short-name-input">{{ $t('matter.short_name') }}</label>
                            <b-form-group>
                                <b-form-input id="matter-short-name-input" size="sm" v-model="shortName" maxlength="50" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                     <b-col class="col-md-3">
                        <b-form>
                            <validation-provider :name="$t('matter.first_lawyer')" #default="{ errors }" :rules="{ excluded: [0] }">
                                <label for="matter-first-lawyer-input">{{ $t('matter.first_lawyer') }}</label>
                                <b-form-select size="sm" v-model="firstLawyerSelect" value-field="id" text-field="name" :options="firstLawyerOption" :state="errors.length > 0 ? false : null" />
                                <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                        </b-form>
                    </b-col>
                     <b-col class="col-md-3">
                        <b-form>
                            <label for="matter-second-lawyer-input">{{ $t('matter.second_lawyer') }}</label>
                            <b-form-select size="sm" v-model="secondLawyerSelect" value-field="id" text-field="name" :options="secondLawyerOption" />
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="col-md-2">
                        <b-form>
                            <validation-provider #default="{ errors }" :name=" $t('matter.agent_ref_no')" rules="required">
                                <label for="matter-agent-reference-no-input">{{ $t('matter.agent_ref_no') }}</label>
                                <b-form-group>
                                    <b-form-input id="matter-agent-reference-no-input" size="sm" v-model="agentReferenceNo" maxlength="100" :state="errors.length > 0 ? false:null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-form>
                    </b-col>
                    <b-col class="col-md-2">
                        <b-form>
                            <label for="matter-operation-record-no-input">{{ $t('matter.operation_record_no') }}</label>
                            <b-form-group>
                                <b-form-input id="matter-operation-record-no-input" size="sm" v-model="operationRecordNo" maxlength="50" />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-md-2">
                        <b-form>
                            <label for="matter-file-type-input">{{ $t('matter.matter_file_type') }}</label>
                            <b-form-select size="sm" v-model="matterFileTypeSelect" value-field="id" text-field="name" :options="matterFileTypeOption" />
                        </b-form>
                    </b-col>
                    <b-col class="col-md-2">
                        <b-form>
                            <label for="matter-status-input">{{ $t('matter.matter_status') }}</label>
                            <b-form-select size="sm" v-model="matterStatusSelect" value-field="id" text-field="name" :options="matterStatusOption" />
                        </b-form>
                    </b-col>
                    <b-col class="col-md-2">
                        <b-form>
                            <label for="matter-record-date-input">{{ $t('matter.record_date') }}</label>
                            <b-form-group>
                                <b-form-input id="matter-record-date-input" size="sm" v-model="recordDate" disabled />
                            </b-form-group>
                        </b-form>
                    </b-col>
                    <b-col class="col-md-2">
                        <b-form>
                            <label for="matter-file-closing-date-input">{{ $t('matter.file_closing_date') }}</label>
                            <b-form-group>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="lawMatterFileClosingDate"></CustomDatePicker>
                            </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                     <b-col class="col-lg-12">
                        <b-form>
                           <b-form-group>
                                <b-form-textarea id="law-matter-note-visible-area" disabled :placeholder=" $t('matter.matter_note')" v-model="lawMatterAllNotesAsString" />
                           </b-form-group>
                        </b-form>
                    </b-col>
                </b-row>
            </validation-observer>
        </b-card>
        <!-- STOCK-2283 -->
       
            <b-card :hidden="hiddenControl">
            <b-col class="col-lg-12">
                <b-form>
                    <b-form-group>
                        <matter-type-history-list :lawMatterId="this.id" :onOperationCreated="onOperationCreated"></matter-type-history-list>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-card>
        
        
        <!-- STOCK-1105 -->
        <b-card :hidden="hiddenControl">
            <b-row>
                <b-col class="mt-2">
                    <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                    
                        <b-tab :title="$t('matter.matter_document')" style="width:100%;">
                            <b-card-text>
                                <matter-document-list :recordId="this.id" :moduleId="22" :getMatterList="getMatterList"></matter-document-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('matter.matter_note')" style="width:100%;">
                            <b-card-text>
                                <matter-note-list :getMatterList="getMatterList" :lawMatterId="this.id"></matter-note-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('matter.evidence')" style="width:100%;">
                            <b-card-text>
                                <law-matter-evidence-list :getLawMatterList="getMatterList" :lawMatterId="this.id"></law-matter-evidence-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('matter.dailywork')" style="width:100%;">
                            <b-card-text>
                                <dailywork-list ref="dailyworkList" :invoiceDetailList="this.invoiceDetailWithSetTimeOut" :getMatterList="getMatterList" :lawMatterId="this.id" :recordNo="this.recordNo" :shortName="this.shortName"></dailywork-list>
                            </b-card-text>
                        </b-tab>
                        <b-tab :title="$t('matter.invoice')" style="width:100%;">
                            <b-card-text>
                                <invoice-detail-list ref="invoiceDetail" :getMatterList="getMatterList" :lawMatterId="this.id"></invoice-detail-list>
                            </b-card-text>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
        </b-card>
    </b-modal>
</div>
</template>

<script>
import { BSpinner } from "bootstrap-vue"

// Kapalı durumunun sabit id'si (LawMatterStatus tablosunda Açık=1, Kapalı=2)
const CLOSED_STATUS_ID = 2

export default {
    components: { BSpinner },
    props: {
        getMatterList: {
            type: Function
        }
    },
    computed: {
        hiddenControl() {
            return this.id == 0
        },
        shouldShowFilesButton() {
            return !!(this.sharePointFolderUrl) && !this.creatingDocuments;
        },
        shouldShowCreateFilesButton() {
            return this.creatingDocuments || (!this.sharePointFolderUrl && this.id > 0);
        }
    },
    watch: {
        agentSelect(val) {
            if (val != null) {
                this.clientId = val.clientId
            } else {
                this.clientId = null;
            }
        },
        invoiceAgentSelect(val) {
            if (val != null) {
                this.clientId = val.clientId
            } else {
                this.clientId = null;
            }
        },
    },
    data() {
        return {
            id: 0,
            clientId: 0,
            matterClientId: 0,
            matterClientSelect: 0,
            matterClientOption: [],
            invoiceAgentSelect: 0,
            invoiceAgentOption: [],
            agentSelect: 0,
            agentOption: [],
            matterStatusSelect: 0,
            matterStatusOption: [],
            initialStatusId: null,
            matterFileTypeSelect: 0,
            matterFileTypeOption: [],
            recordNo: '',
            agentReferenceNo: '',
            operationRecordNo: '',
            recordDate: null,
            name: '',
            shortName: '',
            firstLawyerSelect: 0,
            firstLawyerOption: [],
            secondLawyerSelect: 0,
            secondLawyerOption: [],

            lawMatterAllNotesAsString: "",
            lawClientPowerOfAttorneyDeadlineDate: null,
            lawMatterFileClosingDate: null,
            sharePointFolderUrl: '',
            creatingDocuments: false,
            currentShortname: ''
        }
    },
    methods: {
        // STOCK-2875 Faz 9: Bütçe Raporu'nda "Daily Work'e Taşı" sonrası Dailywork alt-tablosunu canlı yenile.
        reloadDailywork() {
            if (this.$refs.dailyworkList) this.$refs.dailyworkList.getDailyworkList()
        },
        invoiceDetailWithSetTimeOut() {
            setTimeout(() => {
                this.$refs.invoiceDetail.getLawInvoiceListDetail()
            }, 500);
        },
        setMatterClientId(event) {
            if (event != null) {
                this.matterClientId = event.id
            } else {
                this.matterClientId = null;
            }
        },
        onAgentSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.agentSearch(loading, search, this);
            }
        },
        onInvoiceAgentSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.invoiceAgentSearch(loading, search, this);
            }
        },
        agentSearch(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search
                }
                const controller = {
                    name: 'LawClient',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.agentOption = response.data.clientList
                    loading(false)
                })
            }
        },

        invoiceAgentSearch(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    clientAccountingId: 0,
                    clientName: search
                }
                const controller = {
                    name: 'LawClient',
                    actionName: 'GetClientAccountingByClientName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.invoiceAgentOption = response.data.clientList
                    loading(false)
                })
            }
        },

        onSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search(loading, search, vm) {
            if (search.length > 2) {
                const data = {
                    name: search
                }
                const controller = {
                    name: 'LawClient',
                    actionName: 'GetOwnerClientByName'
                }
                const payload = {
                    data: data,
                    controller: controller
                }
                this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                    this.matterClientOption = response.data.clientList
                    loading(false)
                })
            }
        },
        async showInfo(id) {
            this.$refs['matterFormModal'].show()
            this.id = id
            const loader = this.$loading.show({ enforceFocus: false })
            try {
                const response = await this.$store.dispatch('moduleAuth/getInfo', {
                    data: { id: this.id },
                    controller: { name: 'LawMatter' }
                })
                if (response.data.resultStatus == true) {
                    this.setMatterFormData(response.data)
                    await Promise.all([
                        this.loadAgent(response.data.lawMatter.clientAccountingId),
                        this.loadInvoiceAgent(response.data.lawMatter.invoiceClientAccountingId),
                        this.loadMatterClient(response.data.lawMatter.clientId)
                    ])
                } else {
                    this.$bvModal.hide('matterFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            } finally {
                loader.hide()
            }
        },
        setMatterFormData(data) {
            const lawMatter = data.lawMatter
            this.lawMatterAllNotesAsString = data.lawMatterAllNotesAsString
            this.lawClientPowerOfAttorneyDeadlineDate = data.lawClientPowerOfAttorneyDeadlineDate
            this.matterStatusSelect = lawMatter.lawMatterStatusId || 1
            this.initialStatusId = this.matterStatusSelect
            this.matterStatusOption = data.lawMatterStatusList
            this.matterFileTypeSelect = lawMatter.lawMatterFileTypeId || 2
            this.matterFileTypeOption = data.lawMatterFileTypeList
            this.recordNo = lawMatter.recordNo
            this.agentReferenceNo = lawMatter.agentReferenceNo
            this.operationRecordNo = lawMatter.operationRecordNo
            this.name = lawMatter.name
            this.recordDate = this.$formatFn(lawMatter.recordDate)
            this.shortName = lawMatter.shortName || ''
            this.currentShortname = this.shortName
            this.sharePointFolderUrl = lawMatter.sharePointFolderUrl || ''
            this.firstLawyerSelect = lawMatter.firstLawyerId
            this.firstLawyerOption = data.lawMatterFirstLawyerList
            this.secondLawyerSelect = lawMatter.secondLawyerId
            this.secondLawyerOption = data.lawMatterSecondLawyerList
            this.lawMatterFileClosingDate = lawMatter.fileClosingDate
            this.matterStatusOption.splice(0, 0, this.$nullSelected())
            this.matterFileTypeOption.splice(0, 0, this.$nullSelected())
            this.firstLawyerOption.splice(0, 0, this.$nullSelected())
            this.secondLawyerOption.splice(0, 0, this.$nullSelected())
        },
        async loadAgent(clientAccountingId) {
            if (clientAccountingId > 0) {
                const response = await this.$store.dispatch('moduleAuth/customService', {
                    data: { clientAccountingId },
                    controller: { name: 'ClientAccounting', actionName: 'GetClientAccountingByClientName' }
                })
                this.agentOption = response.data.clientList
                this.agentSelect = response.data.clientList[0]
            } else {
                this.agentOption = []
                this.agentSelect = 0
            }
        },
        async loadInvoiceAgent(invoiceClientAccountingId) {
            if (invoiceClientAccountingId > 0) {
                const response = await this.$store.dispatch('moduleAuth/customService', {
                    data: { clientAccountingId: invoiceClientAccountingId },
                    controller: { name: 'ClientAccounting', actionName: 'GetClientAccountingByClientName' }
                })
                this.invoiceAgentOption = response.data.clientList
                this.invoiceAgentSelect = response.data.clientList[0]
            } else {
                this.invoiceAgentOption = []
                this.invoiceAgentSelect = 0
            }
        },
        async loadMatterClient(clientId) {
            if (clientId > 0) {
                const response = await this.$store.dispatch('moduleAuth/customService', {
                    data: { clientId },
                    controller: { name: 'Client', actionName: 'GetOwnerClientByName' }
                })
                this.matterClientOption = response.data.clientList
                this.matterClientSelect = response.data.clientList[0]
                this.clientId = response.data.clientList[0].clientId
            } else {
                this.matterClientOption = []
                this.matterClientSelect = 0
            }
        },
        async confirmCloseWithUninvoicedDailywork() {
            let hasUninvoiced = false
            try {
                const response = await this.$store.dispatch('moduleAuth/customService', {
                    controller: { name: 'LawDailywork', actionName: 'HasUninvoicedDailywork' },
                    data: { id: this.id }
                })
                if (!response.data.resultStatus) {
                    this.$WarningAlert(response.data.resultMessage)
                    return false
                }
                hasUninvoiced = response.data.hasUninvoiced
            } catch (e) {
                this.$WarningAlert(this.$t('matter.uninvoiced_dailywork_check_failed'))
                return false
            }
            if (!hasUninvoiced) {
                return true
            }
            const result = await this.$PrivateConfirm(
                this.$t('matter.uninvoiced_dailywork_title'),
                this.$t('matter.uninvoiced_dailywork_message'),
                'warning',
                this.$t('matter.uninvoiced_dailywork_close_anyway'),
                this.$t('matter.uninvoiced_dailywork_cancel')
            )
            return result.value === true
        },
        async addOrUpdate() {
            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    if (this.matterStatusSelect == CLOSED_STATUS_ID && this.initialStatusId != CLOSED_STATUS_ID && this.id > 0) {
                        const proceed = await this.confirmCloseWithUninvoicedDailywork()
                        if (!proceed) return
                    }
                    const lawMatterData = {
                        id: this.id,
                        clientId: this.matterClientSelect.id,
                        clientAccountingId: this.agentSelect.clientAccountingId,
                        invoiceClientAccountingId: this.invoiceAgentSelect.clientAccountingId,
                        lawMatterStatusId: this.matterStatusSelect,
                        lawMatterFileTypeId: this.matterFileTypeSelect,
                        recordNo: this.recordNo,
                        agentReferenceNo: this.agentReferenceNo,
                        operationRecordNo: this.operationRecordNo,
                        name: this.name,
                        shortName: this.shortName,
                        firstLawyerId: this.firstLawyerSelect,
                        secondLawyerId: this.secondLawyerSelect,
                        fileClosingDate: this.lawMatterFileClosingDate
                    }
                    const data = {
                        lawMatter: lawMatterData
                    }
                    const controller = {
                        name: 'LawMatter'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    const response  = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            // Kayit basarili; SharePoint adimi ayri degerlendirilir, hatasi kaydi geri almaz
                            // ama sessiz de kalmaz (bkz. STOCK-2964).
                            let sharePointWarning = null
                            if (this.id == 0) {

                                this.id = response.data.lawMatterId
                                this.recordNo = response.data.recordNo
                                if(await this.createSharePointMatterFolder()){
                                    if(!await this.updatesharePointFolderUrl()){
                                        sharePointWarning = this.$t('others.sharepoint_url_error')
                                    }
                                } else {
                                    sharePointWarning = this.$t('others.create_files_error')
                                }
                                this.currentShortname = this.shortName
                            }else if(this.sharePointFolderUrl){
                                // Klasoru olmayan dosyada yeniden adlandirilacak bir sey yok.
                                const result = await this.updatesharePointMatterFolderName()
                                if(result){
                                    this.sharePointFolderUrl = this.updateUrlLastSegment(this.sharePointFolderUrl, this.createFileName())
                                    if(!await this.updatesharePointFolderUrl()){
                                        sharePointWarning = this.$t('others.sharepoint_url_error')
                                    }
                                    this.currentShortname = this.shortName
                                } else {
                                    sharePointWarning = this.$t('others.sharepoint_rename_error')
                                }

                            }
                            this.initialStatusId = this.matterStatusSelect
                            if (this.getMatterList && typeof this.getMatterList === 'function') {
                                this.getMatterList()
                            }
                            this.$SaveAlert()
                            if (sharePointWarning) {
                                this.$WarningAlert(sharePointWarning)
                            }
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }

                }

        },
        budgetReport(id) {
            this.$refs.lawMatterBudgetReportForm.showInfo(id)
        },
        async onOperationCreated(seq, typeName, itemId, lawMatterTypeId) {
            if (!this.sharePointFolderUrl) return
            try {
                const operationFolderName = `${String(seq).padStart(2, '0')} ${this.sanitizeSpecials(typeName)}`
                const spResponse = await this.$store.dispatch('moduleAuth/customService', {
                    controller: { name: 'SharePoint', actionName: 'CreateOperationFolder' },
                    data: { matterFolderName: this.createFileName(), operationFolderName, lawMatterTypeId }
                })
                if (!spResponse.data.resultStatus) {
                    console.error('onOperationCreated SP:', spResponse.data.resultMessage)
                    this.$WarningAlert(this.$t('others.sharepoint_operation_error'))
                    return
                }
                const dbResponse = await this.$store.dispatch('moduleAuth/customService', {
                    controller: { name: 'LawMatterMatterTypeHistory', actionName: 'SaveSharePointFolderName' },
                    data: { id: itemId, sharePointFolderName: operationFolderName }
                })
                if (!dbResponse.data.resultStatus) {
                    console.error('onOperationCreated DB:', dbResponse.data.resultMessage)
                    this.$WarningAlert(this.$t('others.sharepoint_operation_error'))
                }
            } catch (e) {
                console.error('onOperationCreated:', e)
                this.$WarningAlert(this.$t('others.sharepoint_operation_error'))
            }
        },
        async onOperationDeleted(sharePointFolderName) {
            if (!this.sharePointFolderUrl || !sharePointFolderName) return
            try {
                const response = await this.$store.dispatch('moduleAuth/customService', {
                    controller: { name: 'SharePoint', actionName: 'DeleteOperationFolder' },
                    data: { matterFolderName: this.createFileName(), operationFolderName: sharePointFolderName }
                })
                if (!response.data.resultStatus) {
                    console.error('onOperationDeleted:', response.data.resultMessage)
                    this.$WarningAlert(this.$t('others.sharepoint_operation_delete_error'))
                }
            } catch (e) {
                console.error('onOperationDeleted:', e)
                this.$WarningAlert(this.$t('others.sharepoint_operation_delete_error'))
            }
        },
        // Musteri kodu tire icerebilir; dosya numarasi son segment, musteri kodu oncesinin tamami.
        clientNoOnly(){
            const parts = (this.recordNo || '').split('-')
            return parts.length > 1 ? parts.slice(0, -1).join('-') : ''
        },
        buildSharePointMatterData() {
            return {
                clientNo: this.clientNoOnly(),
                clientName: this.matterClientSelect.name,
                agentName: this.agentSelect.clientName,
                matterName: this.name,
                matterNo: this.matterNoOnly(),
                shortName: this.shortName
            }
        },
        async createSharePointMatterFolder(){
            try {
                const spPayload = {
                    controller: {name: 'SharePoint', actionName: 'CreateMatterFolderWithColumns'},
                    data: { fileName: this.createFileName(), ...this.buildSharePointMatterData() }
                }
                const spResponse = await this.$store.dispatch('moduleAuth/customService', spPayload)
                if(spResponse.data.resultStatus){
                    this.sharePointFolderUrl = spResponse.data.webUrl
                    return true
                }
                console.error('createSharePointMatterFolder:', spResponse.data.resultMessage)
                return false
            } catch(e) {
                console.error('createSharePointMatterFolder:', e)
                return false
            }
        },
        async createAllDocuments() {
            if (this.id <= 0 || this.sharePointFolderUrl || this.creatingDocuments) return
            this.creatingDocuments = true
            try {
                // 1) Matter klasörü
                await this.createSharePointMatterFolder()
                if (!this.sharePointFolderUrl) {
                    this.$WarningAlert(this.$t('others.create_files_error'))
                    return
                }
                await this.updatesharePointFolderUrl()
                this.currentShortname = this.shortName

                // 2) Matter'ın operation'larını çek
                const listResponse = await this.$store.dispatch('moduleAuth/customService', {
                    controller: { name: 'LawMatterMatterTypeHistory', actionName: 'GetLawMatterMatterTypeHistoryListByLawMatterId' },
                    data: { id: this.id }
                })
                if (!listResponse.data.resultStatus) {
                    this.$WarningAlert(listResponse.data.resultMessage)
                    return
                }
                const operations = (listResponse.data.lawMatterMatterTypeHistoryList || [])
                    .slice()
                    .sort((a, b) => a.id - b.id)

                // 3) Her operation için klasör + alt klasör (CreateOperationFolder alt klasörleri de açar)
                const failed = []
                for (let i = 0; i < operations.length; i++) {
                    const row = operations[i]
                    if (row.sharePointFolderName) continue // idempotent: zaten var
                    const seq = i + 1
                    const operationFolderName = `${String(seq).padStart(2, '0')} ${this.sanitizeSpecials(row.lawMatterTypeName)}`
                    try {
                        const spResponse = await this.$store.dispatch('moduleAuth/customService', {
                            controller: { name: 'SharePoint', actionName: 'CreateOperationFolder' },
                            data: { matterFolderName: this.createFileName(), operationFolderName, lawMatterTypeId: row.lawMatterTypeId }
                        })
                        if (!spResponse.data.resultStatus) {
                            console.error('createAllDocuments SP:', spResponse.data.resultMessage)
                            failed.push(operationFolderName)
                            continue
                        }
                        const dbResponse = await this.$store.dispatch('moduleAuth/customService', {
                            controller: { name: 'LawMatterMatterTypeHistory', actionName: 'SaveSharePointFolderName' },
                            data: { id: row.id, sharePointFolderName: operationFolderName }
                        })
                        if (!dbResponse.data.resultStatus) {
                            console.error('createAllDocuments DB:', dbResponse.data.resultMessage)
                            failed.push(operationFolderName)
                        }
                    } catch (e) {
                        console.error('createAllDocuments operation:', e)
                        failed.push(operationFolderName)
                    }
                }

                if (failed.length === 0) {
                    this.$CustomAlert(this.$t('others.create_files_success'), 'success')
                } else {
                    this.$WarningAlert(this.$t('others.create_files_partial') + ' ' + failed.join(', '))
                }
            } catch (e) {
                console.error('createAllDocuments:', e)
                this.$WarningAlert(e.message || String(e))
            } finally {
                this.creatingDocuments = false
            }
        },
        async updatesharePointMatterFolderName(){
            try {
                const payload = {
                    controller: {name: 'SharePoint', actionName: 'UpdateMatterFolderNameWithColumns'},
                    data: {
                        currentFileName: this.createCurrentFileName(),
                        newFileName: this.createFileName(),
                        ...this.buildSharePointMatterData()
                    }
                }
                const response = await this.$store.dispatch('moduleAuth/customService', payload)
                if(!response.data.resultStatus) console.error('updatesharePointMatterFolderName:', response.data.resultMessage)
                return response.data.resultStatus
            } catch(e) {
                console.error('updatesharePointMatterFolderName:', e)
                return false
            }
        },
        async updatesharePointFolderUrl(){
            try {
                const controller = {name: 'LawMatter', actionName: 'SaveSharePointFolderUrl'}
                const payload = { controller: controller, data: { id: this.id, sharePointFolderUrl: this.sharePointFolderUrl } }
                const response = await this.$store.dispatch('moduleAuth/customService', payload)
                if(!response.data.resultStatus) console.error('updatesharePointFolderUrl:', response.data.resultMessage)
                return response.data.resultStatus
            } catch(e) {
                console.error('updatesharePointFolderUrl:', e)
                return false
            }
        },
        sanitizeSpecials(input){
            return input.replace(/\s*([\"*\:\<\>\?\/\\\|])\s*/g, '_');
        },
        updateUrlLastSegment(url, newFileName) {
            const cleanUrl = url.replace(/\/+$/, '');
            return cleanUrl.substring(0, cleanUrl.lastIndexOf('/') + 1) + newFileName;
        },
        openMatterFolder(){
            window.open(this.sharePointFolderUrl, "_blank");
        },
        // Klasor adi dosya numarasiyla baslar; musteri kodu SharePoint tarafinda ClientNo kolonunda tutuluyor.
        // Musteri kodu tire icerebildigi icin dosya numarasi son segmenttir (API tarafi da boyle uretiyor).
        matterNoOnly(){
            const parts = (this.recordNo || '').split('-')
            return parts.length > 1 ? parts[parts.length - 1] : this.recordNo
        },
        createFileName(){
            let fileName = this.matterNoOnly()
            if(this.shortName){
                fileName = fileName + '-' + this.sanitizeSpecials(this.shortName)
            }
            return fileName;
        },
        createCurrentFileName(){
            let fileName = this.matterNoOnly()
            if(this.currentShortname){
                fileName = fileName + '-' + this.sanitizeSpecials(this.currentShortname)
            }
            return fileName;
        },
        
    }
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
